export default function() {
	return {
		init: false,
		loading: false,
		stats: [],
		selectedRange: 'last_week_mon_sun',

		pageViewSum: 0,
		pageViewChart: [],

		pageLikesSum: 0,
		pageLikesChart: [],

		pageActionsSum: 0,
		pageActionsChart: [],

		postEngagementSum: 0,
		postEngagementChart: [],

		pageFollowsSum: 0,
		pageFollowsChart: [],

		pageImpressionsSum: 0,
		pageImpressionsChart: [],

		pageFansGenderAgeChart: {},
		pageFansCity: [],
		pageFansCountry: [],
		pageFansLocale: [],

		pageFollowsGenderAgeChart: {},
		pageFollowsCity: [],
		pageFollowsLocale: [],

		pageImpressionsByAgeGenderUniqueChart: {},
		pageImpressionsByCityUnique: [],
		pageImpressionsByCountryUnique: [],
		pageImpressionsByLocaleUnique: [],

		pageContentActivityByAgeGenderUniqueChart: {},
		pageContentActivityByCityUnique: [],
		pageContentActivityByCountryUnique: [],
		pageContentActivityByLocaleUnique: [],
	};
}
